import { useState } from 'react';
import { NJButton, NJHeading, NJText } from '@engie-group/fluid-design-system-react';
import { UMSelect } from '../../urbanmap/_components';
import { DecisionPanel } from './DecisionPanel';
import type { Destination } from './types';

const SCREENS: { title: string; destination: Destination; zones: string[] }[] = [
  { title: '1 · Données du projet', destination: 'data', zones: ['Liste et couches locales', 'Carte et légende par énergie', 'Fiche du bâtiment sélectionné'] },
  { title: '2 · Correction bâtiment', destination: 'data', zones: ['Identité et données sources', 'Calcul / correction / valeur effective', 'Chaleur et froid séparés · bornes à arbitrer'] },
  { title: '3 · Paramètres', destination: 'settings', zones: ['Général / ratios / DJU', 'Aperçu avant enregistrement', 'Paramètres métier et droits à arbitrer'] },
  { title: '4 · Synchronisation', destination: 'sync', zones: ['Écarts projet / UrbanMap', 'Impacts et corrections conservées', 'Conflits : résolution à arbitrer'] },
  { title: '5 · Scénario', destination: 'scenario', zones: ['Scénarios → plans', 'Routes / exceptions / départs', 'Carte et inspecteur des hypothèses'] },
  { title: '6 · Plan', destination: 'plan', zones: ['Scénario parent et plans', 'Carte : abonnés et tracé', 'Abonnés / canalisations / phasage'] },
  { title: '7 · Recalcul', destination: 'plan', zones: ['Prérequis et hypothèses', 'Confirmation des conséquences', 'Succès / annulation / échec conservant le plan'] },
  { title: '8 · Comparaison', destination: 'compare', zones: ['Choix de plans inter-scénarios', 'Énergie / date / validité', 'Métriques et limite à arbitrer'] },
];
export function Wireframes({ visit, close }: { visit: (d: Destination) => void; close: () => void }) {
  const [screen, setScreen] = useState('0');
  const s = SCREENS[Number(screen)];
  return <div className="pu-review sp-stack">
    <div className="sp-row sp-between">
      <NJHeading as="h1" scale="lg">Plan unifié · revue basse fidélité</NJHeading>
      <NJButton label="Explorer la démonstration" onClick={close} icon="arrow_forward" />
    </div>
    <NJText>Structure décidée : projet ouvert → Données du projet / Étude → scénario → plans.
      Cette revue n’approuve pas les questions métier ouvertes. Aucun ancien prototype n’est remplacé.</NJText>
    <UMSelect ariaLabel="Écran de la revue" value={screen} onChange={setScreen}
      options={SCREENS.map((item, i) => ({ value: String(i), label: item.title }))} />
    <section className="pu-wireframe sp-stack" aria-label={s.title}>
      <NJHeading as="h2" scale="md">{s.title}</NJHeading>
      <div className="pu-wire-header"><NJText>PLAN · Gentilly · Données du projet / Étude · Paramètres · Écarts UM · Décisions ouvertes</NJText></div>
      <div className="pu-wire-zones">{s.zones.map((zone, i) => <div className="pu-wire-zone" key={zone}>
        <NJText as="div"><strong>{i + 1}. {zone}</strong></NJText>
      </div>)}</div>
      <NJButton label="Ouvrir cet écran dans la démonstration" emphasis="subtle" onClick={() => visit(s.destination)} />
    </section>
    <DecisionPanel selected={null} visit={visit} close={close} />
  </div>;
}
